import { TextareaAutosize } from '@mui/material'
import React from 'react'
import DiagnosisSelectMenu from 'src/mentor/components/PrescriptionMakingPage/inputComponents/diagnosis/DiagnosisMenu'
import { SuggestedTherapySelectMenu } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageComponents'
import { PMPSectionInputLabel } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import EMRNextVisitComponent from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/components/prescriptionMakingPageComponents/EMRNextVisitComponent'

export default function SendTherapyComponent({
  clinicId,
  clinicBrandId,
  selectedDiagnosis,
  setSelectedDiagnosis,
  nextVisitInputValue,
  setNextVisitInputValue,
  nextVisitInputType,
  setNextVisitInputType,
  bookedEventInfo,
  loading,
  notesToTherapist,
  setNotesToTherapist,
  selectedTherapies,
  setSelectedTherapies,
}) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <div className="w-100">
        <DiagnosisSelectMenu
          clinicId={clinicId}
          clinicBrandId={clinicBrandId}
          selectedDiagnosis={selectedDiagnosis}
          setSelectedDiagnosis={setSelectedDiagnosis}
          menuPortalTarget={document.body}
          maxZIndex
          isLoading={loading}
        />
      </div>
      <div style={{ width: '100%' }}>
        <PMPSectionInputLabel main className="d-flex align-items-center gap-2">
          Suggested Therapies
        </PMPSectionInputLabel>
        <SuggestedTherapySelectMenu
          selectedTherapies={selectedTherapies}
          setSelectedTherapies={setSelectedTherapies}
          menuPortalTarget={document.body}
          maxZIndex
        />
      </div>
      <div className="w-100">
        <div className="w-100">
          <PMPSectionInputLabel main className="d-flex align-items-center gap-2">
            <div>Notes to Psychologist for Therapy</div>
          </PMPSectionInputLabel>
          <TextareaAutosize
            placeholder="Enter notes that you want to send to the psychologists who will take this case..."
            className="pmpTextarea-focus pmp-rounded-box"
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #cecece',
              background: '#fff',
            }}
            value={notesToTherapist}
            onChange={(e) => {
              setNotesToTherapist(e.target.value)
            }}
          />
        </div>
      </div>
      <div className="w-100">
        <EMRNextVisitComponent
          nextVisitInputValue={nextVisitInputValue}
          setNextVisitInputValue={setNextVisitInputValue}
          nextVisitInputType={nextVisitInputType}
          setNextVisitInputType={setNextVisitInputType}
          bookedEventInfoStartTime={bookedEventInfo?.startTime}
          currentEventTypeId={bookedEventInfo?.eventTypeId}
          hideHoldSlotForNextVisit
          currentPatient={bookedEventInfo?.patient}
          currentFee={bookedEventInfo?.fee}
          currentBookedEventId={bookedEventInfo?.id}
          nextVisitBookedEventId={bookedEventInfo?.nextVisitReferenceBookedEventId}
        />
      </div>
    </div>
  )
}
